/** Абстракция постоянного хранилища. */
export interface StorageAdapter {
  get<T>(key: string): Promise<T | null>;
  set<T>(key: string, value: T): Promise<void>;
  remove(key: string): Promise<void>;
}

/** Web-реализация через localStorage с JSON-сериализацией. */
export class LocalStorageAdapter implements StorageAdapter {
  /** Читает и десериализует значение по ключу. */
  get<T>(key: string): Promise<T | null> {
    try {
      const raw = localStorage.getItem(key);
      const result = raw === null ? null : (JSON.parse(raw) as T);
      return Promise.resolve(result);
    } catch {
      return Promise.resolve(null);
    }
  }

  /** Сериализует и записывает значение по ключу. */
  set<T>(key: string, value: T): Promise<void> {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // quota exceeded — no-op
    }
    return Promise.resolve();
  }

  /** Удаляет запись по ключу. */
  remove(key: string): Promise<void> {
    try {
      localStorage.removeItem(key);
    } catch {
      // no-op
    }
    return Promise.resolve();
  }
}
